const EMBED_URL_MARKER = "/embed/";

const normalizeId = (value) =>
    value === null || value === undefined ? "" : String(value).trim();

export const getAssetEmbedUrl = (assets, assetId) => {
    const wantedId = normalizeId(assetId);
    if (!wantedId) return "";

    const asset = (assets || []).find(
        (candidate) => normalizeId(candidate?.asset_id) === wantedId,
    );

    return normalizeId(asset?.pointerra_embed_url);
};

export const getDefectEmbedUrl = (assets, defect) =>
    normalizeId(defect?.pointerra_embed_url) ||
    getAssetEmbedUrl(assets, defect?.asset_id);

export const isEmbeddableTwinUrl = (url) =>
    normalizeId(url).includes(EMBED_URL_MARKER);
